{
  "error": {
    "server_connection_failed": "Erreur de connexion au serveur.  "
  },
  "term": {
    "affects_all_instances": "Affects all {count} instances",
    "affects_this_instance_only": "Affects only this instance",
    "application": "Application",
    "attributes": "Attributs",
    "bytes": "Octets",
    "cancel": "Annuler",
    "clear": "Effacer",
    "cleared": "Effacé",
    "close": "Fermer",
    "confirm": "Confirmer",
    "delete": "Supprimer",
    "deleted": "Supprimé",
    "duration": "Durée",
    "event": "Evènement",
    "ever": "Toujours",
    "executing": "Exécution...",
    "execution_failed": "Exécution en échec.",
    "execution_successful": "Exécution en succès.",
    "failed": "Echec",
    "float": "Décimal",
    "hours": "{count} heure | {count} heures",
    "instances": "Instances",
    "integer": "Entier",
    "milliseconds": "Millisecondes",
    "minutes": "{count} minute | {count} minutes",
    "percent": "pour cent",
    "name": "Nom",
    "operations": "Opérations",
    "save": "Sauvegarder",
    "stacktrace": "Stacktrace",
    "suppress": "Supprimer",
    "time": "Temps",
    "unsuppress": "Désinscription",
    "username": "Identifiant"
  },
  "time_short": {
    "unknown": "unknown",
    "milliseconds": "{count}ms",
    "seconds": "{count}s",
    "minutes": "{count}min",
    "hours": "{count}h",
    "days": "{count}j",
    "weeks": "{count}sem",
    "months": "{count}m",
    "years": "{count}a"
  }
}
